import React, { useState } from "react";
import CustomLabelPreview from "./CustomLabelPreview";
import { generateCustomPDF } from "./CustomLabelPDF";

const inputStyle = {
  width: "100%",
  padding: "10px",
  borderRadius: 8,
  border: "1px solid #ccc",
  boxSizing: "border-box",
};

export default function CustomLabelPage() {

  const [labelWidth, setLabelWidth] =
    useState(3);

  const [labelHeight, setLabelHeight] =
    useState(2.5);

  const [gridGap, setGridGap] =
    useState(2);

  const [showBorder, setShowBorder] =
    useState(true);

  const [imagePreview, setImagePreview] =
    useState("");

  const [uploadedImage, setUploadedImage] =
    useState(null);

  const handleUpload = (e) => {

    const file = e.target.files?.[0];

    if (!file) return;

    const reader = new FileReader();

    reader.onload = () => {

      setUploadedImage(file);

      setImagePreview(
        reader.result
      );

    };

    reader.readAsDataURL(file);

  };

  return (

    <div
      style={{
        padding: 24,
        maxWidth: 1100,
        margin: "0 auto",
      }}
    >

      <h1>
        Custom Label Generator
      </h1>

      <div
        style={{
          display: "grid",
          gridTemplateColumns:
            "repeat(auto-fit,minmax(250px,1fr))",
          gap: 20,
          marginTop: 20,
        }}
      >

        {/* Width */}

        <div>

          <label>
            Width (cm)
          </label>

          <input
            type="number"
            step="0.1"
            min="0.1"
            value={labelWidth}
            onChange={(e) =>
              setLabelWidth(
                Number(
                  e.target.value
                )
              )
            }
            style={inputStyle}
          />

        </div>

        {/* Height */}

        <div>

          <label>
            Height (cm)
          </label>

          <input
            type="number"
            step="0.1"
            min="0.1"
            value={labelHeight}
            onChange={(e) =>
              setLabelHeight(
                Number(
                  e.target.value
                )
              )
            }
            style={inputStyle}
          />

        </div>

        {/* Gap */}

        <div>

          <label>
            Grid Gap (mm)
          </label>

          <input
            type="number"
            step="0.1"
            min="0"
            value={gridGap}
            onChange={(e) =>
              setGridGap(
                Number(
                  e.target.value
                )
              )
            }
            style={inputStyle}
          />

        </div>

        {/* Border */}

        <div>

          <label>
            Border Mode
          </label>

          <select
            value={
              showBorder
                ? "border"
                : "none"
            }
            onChange={(e) =>
              setShowBorder(
                e.target.value ===
                  "border"
              )
            }
            style={inputStyle}
          >

            <option value="border">
              Border Around Image
            </option>

            <option value="none">
              No Border
            </option>

          </select>

        </div>

        {/* Upload */}

        <div>

          <label>
            Upload Image
          </label>

          <input
            type="file"
            accept="image/*"
            onChange={handleUpload}
            style={inputStyle}
          />

        </div>

      </div>

      {/* Preview */}

      <div
        style={{
          marginTop: 30,
        }}
      >

        <h2>
          Preview
        </h2>

        <CustomLabelPreview
          labelWidth={labelWidth}
          labelHeight={labelHeight}
          imagePreview={imagePreview}
          showBorder={showBorder}
        />

      </div>

      {/* Info */}

      <div
        style={{
          marginTop: 20,
          padding: 15,
          background: "#f8fafc",
          borderRadius: 10,
        }}
      >

        <div>
          Label Size :
          {" "}
          {labelWidth}
          cm ×
          {" "}
          {labelHeight}
          cm
        </div>

        <div>
          Grid Gap :
          {" "}
          {gridGap}
          mm
        </div>

        <div>
          Border :
          {" "}
          {showBorder
            ? "Enabled"
            : "Disabled"}
        </div>

      </div>

      {/* Download */}

      <div
        style={{
          marginTop: 30,
        }}
      >

        <button
          onClick={() =>
            generateCustomPDF({

              imagePreview,

              labelWidth,

              labelHeight,

              gridGap,

              showBorder,

            })
          }
          style={{
            padding:
              "12px 24px",
            border: "none",
            borderRadius: 10,
            cursor: "pointer",
            background:
              "#2563eb",
            color: "#fff",
            fontWeight: 700,
            fontSize: 15,
          }}
        >
          Download PDF
        </button>

      </div>

    </div>

  );

}